module.exports = __webpack_public_path__ + "img/refresh.3d0bd9c5.png";